import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Modal, Row, Col } from 'react-bootstrap';
import { XCircleFillIcon } from '@primer/octicons-react';

import { submitSets } from '../../UiComponents/SubmitSets';
import { submitCollection } from '../../../_services/submit.service';
import { alertService } from '../../../_services/alert.service';

import { AcLightBox } from '../../UiComponents/AcImports';
import i18n from "../../../_translations/i18n";
import './imagePreview.css';

export class ImagePreviewComponent extends React.Component{
    _isMounted = false;

    constructor(props){
        super(props);
        this.state = {
            isloaded:false, isImageLoaded:false, usedFallback:false,
            cobj: {barcode:"",productName:"",brandName:"", imageUrl:""},
        }
    }

    componentDidMount(){
        this._isMounted = true;
        if(this._isMounted){
            if(this.props.loadfromback===true){
                this.loadData(this.props.productid);
            }
            else{
                const imageUrl = this.props.imgurl;
                this.setState({
                    isloaded: true,
                    isImageLoaded: !imageUrl, // Set to true if no image URL
                    cobj: {barcode:"", productName:"", imageUrl: imageUrl}
                });
            }

        }
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    loadData = (id) =>{
        if(id){
            submitSets(submitCollection.findProdImageData, ('?productId='+id), true).then(res => {
                this.setState({isloaded:true});
                if(res && res.status){
                    // findBiggerPictureProduct resolves the Original variant through
                    // a presigned URL on the private bucket, which fails far more
                    // often than the thumbnail a caller already has on screen (that
                    // one comes off the CloudFront cache path). When the caller hands
                    // us that thumbnail, use it whenever the big picture is missing.
                    const bigUrl = res.extra?.imageUrl;
                    const imageUrl = bigUrl || this.props.fallbackimgurl || "";
                    this.setState({
                        cobj: {...res.extra, imageUrl},
                        usedFallback: !bigUrl && imageUrl !== "",
                        isImageLoaded: !imageUrl // Set to true if no image URL
                    });
                } else{
                    alertService.error(i18n.t("ERROR_OCCURRED"));
                    this.props.handlePreviewModal(null,false);
                }
            });
        }
        else{
            this.props.handlePreviewModal(null,false);
        }
    }

    handleImageLoader = (type) =>{
        this.setState({isImageLoaded:type});
    }

    handleImageLoadError = (e) =>{
        // A dead presigned URL (expired, or an Original variant that was never
        // created) reaches us as a load error, not an API failure. Retry once
        // with the caller's own thumbnail before showing the broken box: the
        // smaller image is a far better answer than none.
        const fallback = this.props.fallbackimgurl;
        if(fallback && this.state.usedFallback !== true && fallback !== this.state.cobj.imageUrl){
            this.setState(prev => ({
                usedFallback: true,
                isImageLoaded: false,
                cobj: {...prev.cobj, imageUrl: fallback}
            }));
            return;
        }
        this.setState({isImageLoaded:true});
        alertService.error(i18n.t("COULD_NOT_THE_LOAD_IMAGE"));
    }

    handleImgClose = () => {
        this.props.handlePreviewModal(null,false);
    }

    render(){
        return(this.props.hideheaderlables?<>
            {this.props.isshow?<AcLightBox 
                showcount={false} allowZoom={true} allowReset={true}
                datalist={this.state.cobj.imageUrl?[this.state.cobj.imageUrl]:[]}
                onClose={this.handleImgClose}
                />:<></>}
        </>:<>
            <Modal className="img-preview-modal" show={this.props.isshow} dir={this.props.isRTL} centered={true} onHide={() => this.props.handlePreviewModal(null,false)} animation={false} backdrop="static">
                <Modal.Body className="text-center">
                    <span onClick={() => this.props.handlePreviewModal(null,false)} style={{position:"absolute",right:"8px",cursor:"pointer"}}><XCircleFillIcon size={20}/></span>
                    {
                        this.state.isloaded === false ?
                        <Col className='loading-anim-div' style={{paddingTop:"16%"}}>
                            <div className="animewrapper animation-2 col-centered">
                                <div className="shape shape1"></div>
                                <div className="shape shape2"></div>
                                <div className="shape shape3"></div>
                                <div className="shape shape4"></div>
                            </div>
                        </Col>
                        :<></>
                    }

                    <Col className={this.state.isloaded === true ? "" :"d-none"}>
                        <Col className={'data-values ' +(this.props.hideheaderlables===true?"d-none":"")}>
                            <Row>
                                <Col xs={3} className="label-field">{this.props.t('productname')} </Col>
                                <Col xs={9} className="value-field">{this.state.cobj.productName}</Col>
                            </Row>
                            <Row>
                                <Col xs={3} className="label-field">{this.props.t('productbrand')}</Col>
                                <Col xs={9} className="value-field">{(this.state.cobj.brandName && this.state.cobj.brandName !== ""?this.state.cobj.brandName:this.props.t("notavailable"))}</Col>
                            </Row>
                            <Row>
                                <Col xs={3} className="label-field">{this.props.t('barcode')}</Col>
                                <Col xs={9} className="value-field">{this.state.cobj.barcode}</Col>
                            </Row>

                        </Col>

                        {
                            this.state.isImageLoaded === false ?
                            <div className='loading-anim-div' style={{paddingTop:"16%"}}>
                                <div className="animewrapper animation-2 col-centered">
                                    <div className="shape shape1"></div>
                                    <div className="shape shape2"></div>
                                    <div className="shape shape3"></div>
                                    <div className="shape shape4"></div>
                                </div>
                            </div>
                            :
                            <></>
                        }

                        <Col style={{marginTop:(this.props.hideheaderlables===true?"40px":"10px")}} className={"img-wrapper "+(this.state.isImageLoaded === true ? "" :"d-none")}>
                            {this.state.cobj.imageUrl ? (
                                <img
                                    src={this.state.cobj.imageUrl}
                                    onLoadStart={()=>this.handleImageLoader(false)}
                                    onLoad={()=>this.handleImageLoader(true)}
                                    onError={(e)=>this.handleImageLoadError(e)}
                                    className={(this.state.cobj && this.state.cobj.width >= this.state.cobj.height)?"img-resize-ver":"img-resize-hor"}
                                    style={{height:"15rem"}}
                                    alt=""/>
                            ) : (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '15rem',
                                    color: '#fff',
                                    fontSize: '1rem'
                                }}>
                                    {this.props.t('NO_IMAGE_AVAILABLE')}
                                </div>
                            )}
                        </Col>
                    </Col> 
                </Modal.Body>
            </Modal>
        </>)
    }

}

export default withTranslation()(withRouter(ImagePreviewComponent));